import { createAction, props } from '@ngrx/store';
import { Tab } from '../../services/tab/tab.service';
import { LyftState } from './lyft.reducer';
import { LyftDispatchRideStatus, LyftDispatchRideTracker, LyftDispatchRideTrackerDetail } from '@uzurv/clara';
import { PageEvent } from '@angular/material/paginator';
import { LYFT_PARAMS_KEY } from '../../pages/lyft/lyft.page';

export const Start = createAction('[Lyft] Start Tab', props<Tab<LyftState>>());

export const StartSuccess = createAction('[Lyft] Start Tab Success');

export const Activated = createAction('[Lyft] Activated Tab', props<Tab<LyftState>>());

export const Closed = createAction('[Lyft] Closed Tab');

export const InitialDataLoaded = createAction('[Lyft] Initial Data Loaded');

export const RestoreSnapshot = createAction('[Lyft] Restore Snapshot', props<{ state: LyftState }>());

export const FetchLyftRides = createAction('[Lyft] Fetch Lyft Rides');

export const FetchLyftRidesSuccess = createAction('[Lyft] Fetch Lyft Rides Success', props<{ rides: LyftDispatchRideTracker[] }>());

export const FetchLyftRidesFailure = createAction('[Lyft] Fetch Lyft Rides Failed', props<{ error: any }>());

export const FetchLyftStatuses = createAction('[Lyft] Fetch Lyft Statuses');

export const FetchLyftStatusesSuccess = createAction('[Lyft] Fetch Lyft Statuses Success', props<{ statuses: LyftDispatchRideStatus[] }>());

export const FetchLyftStatusesFailure = createAction('[Lyft] Fetch Lyft Statuses Failed', props<{ error: any }>());

export const SelectRide = createAction('[Lyft] Set Selected Ride ID', props<{ ride: LyftDispatchRideTracker }>());

export const SetPagination = createAction('[Lyft] Set Pagination', props<{ pagination: PageEvent }>());

export const SetSearch = createAction('[Lyft] Set Search', props<{ search: string }>());

export const SetFilters = createAction('[Lyft] Set Filters', props<{ filters: number[] }>());

export const SyncUrlToStore = createAction('[Lyft] Sync URL to Store');

export const FetchLyftListData = createAction(
  '[Lyft] Fetch Lyft List Data',
  props<{
    ride: number | null;
    pageIndex: number | null;
    pageSize: number | null;
    search: string | null;
    filters: number[] | null;
  }>()
);

export const FetchLyftListDataSuccess = createAction('[Lyft] Fetch Lyft List Data Success');

export const FetchLyftRideDetails = createAction('[Lyft] Fetch Lyft Ride Details', props<{ ride: number }>());

export const FetchLyftRideDetailsSuccess = createAction(
  '[Lyft] Fetch Lyft Ride Details Success',
  props<{ ride: LyftDispatchRideTrackerDetail }>()
);

export const FetchLyftRideDetailsFailure = createAction('[Lyft] Fetch Lyft Ride Details Failed', props<{ error: any }>());

export const RefreshLyftRides = createAction('[Lyft] Refresh Lyft Rides');

export const SetLyftParams = createAction('[Lyft] Update Lyft Params', props<{ state: Pick<LyftState, typeof LYFT_PARAMS_KEY> }>());
